var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 295,
    viewBox: "0 0 375 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2741 244.673C57.4138 239.44 50.3875 232.361 44.6825 223.865C38.9777 215.368 34.7396 205.669 32.2598 195.397C29.7801 185.125 29.1218 174.542 30.3147 164.341C31.5077 154.14 34.5213 144.582 39.1183 136.273",
    stroke: "#CFECFA",
    strokeWidth: 8.61793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0423 226.429C76.283 222.678 70.347 217.522 65.6237 211.29C60.9004 205.057 57.4976 197.891 55.6392 190.253C53.7808 182.616 53.5095 174.685 54.8403 166.975C56.1711 159.265 59.0734 151.951 63.3527 145.507",
    stroke: "#CFECFA",
    strokeWidth: 8.61793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.24 209.533C94.4496 206.998 89.4968 203.431 85.6644 199.103C81.8352 194.779 79.1954 189.777 77.8779 184.423C76.5604 179.069 76.5812 173.429 77.9699 167.851C79.3598 162.268 82.0958 156.849 86.0544 151.963",
    stroke: "#CFECFA",
    strokeWidth: 8.61793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.513 181.479C344.29 173.334 347.51 163.894 348.922 153.758C350.333 143.622 349.899 133.046 347.634 122.725C345.368 112.403 341.328 102.599 335.792 93.949C330.255 85.2989 323.362 78.0232 315.593 72.5639",
    stroke: "#CFECFA",
    strokeWidth: 8.61793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.551 172.851C319.988 166.52 323.069 159.287 324.588 151.616C326.108 143.945 326.031 136.012 324.36 128.331C322.689 120.651 319.462 113.401 314.891 107.05C310.32 100.7 304.51 95.3946 297.842 91.4725",
    stroke: "#CFECFA",
    strokeWidth: 8.61793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292.694 165.186C296.792 160.372 299.684 154.997 301.236 149.429C302.786 143.865 302.971 138.212 301.813 132.821C300.654 127.431 298.168 122.369 294.478 117.961C290.785 113.549 285.953 109.874 280.256 107.213",
    stroke: "#CFECFA",
    strokeWidth: 8.61793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.112 103.437C277.941 178.136 200.491 283.856 168.808 261.839C143.864 244.507 162.312 216.147 149.944 189.251C137.738 162.706 116.889 168.231 107.539 127.645C98.01 86.2847 124.821 44.7451 166.414 36.289C209.601 27.5088 242.33 50.424 257.112 103.437Z",
    fill: "#FFCA28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.918 148.245C207.282 126.46 166.506 103.37 166.506 103.37C166.506 103.37 190.8 99.4869 208.75 123.557C222.704 142.269 232.441 181.783 232.441 181.783C232.441 181.783 263.556 99.8153 205.318 64.0773C159.852 36.1764 122.787 95.0734 132.921 126.499C141.901 154.347 192.24 170.958 199.918 148.245Z",
    fill: "#CE9C1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.218 171.557C173.831 170.448 166.719 163.746 161.502 165.217C148.47 168.893 183.165 176.25 186.333 189.415C188.489 198.376 180.448 203.593 181.218 208.117C184.333 226.435 220.436 176.941 203.77 168.727C195.761 164.78 191.07 172.727 182.218 171.557Z",
    fill: "#CE9C1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEar);
export default __webpack_public_path__ + "static/media/ear.e54a54b1.svg";
export { ForwardRef as ReactComponent };